import { getTranslations } from "next-intl/server"

import { PRODUCT_PHOTO_QUALITY, TileImage } from "@/components/ui/tile-image"

interface PdpImageStackProps {
  images: string[]
  title: string
  className?: string
}

const STACK_LIMIT = 4

export const PdpImageStack = async ({ images, title, className }: PdpImageStackProps) => {
  const t = await getTranslations("pdp")
  const rest = images.slice(1, 1 + STACK_LIMIT)
  if (rest.length === 0) return null
  return (
    <div className={`max-w-takeover mx-auto flex w-full flex-col gap-250 @3xl:hidden ${className ?? ""}`}>
      {rest.map((src, index) => (
        <div key={src} className="border-line-faint bg-surface-paper rounded-10x shadow-thumb relative aspect-square overflow-hidden border">
          <TileImage src={src} alt={t("gallery.imageAlt", { title, index: index + 2 })} fill sizes="100vw" quality={PRODUCT_PHOTO_QUALITY} className="object-contain" />
        </div>
      ))}
    </div>
  )
}
